import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import './BlockHeading.custom.scss';
import './BlockHeading.theme.scss';

function BlockHeading({ title, withResetButton, onResetClick }) {
  return (
    <div className="heading">
      {withResetButton && (
        // eslint-disable-next-line react/button-has-type
        <button className="rx-btn rx-btn--small rx-btn--basic_link blue rx-btn--right heading-reset" onClick={onResetClick}>
          <span className="rx-btn-text">
            <span className="rx-btn-text-container ng-binding">Reset to default</span>
          </span>
          <span className="rx-btn-icon">
            <i className="ss-replay" />
          </span>
        </button>
      )}
      <div className="heading-title">{title}</div>
    </div>
  );
}

BlockHeading.propTypes = {
  title: PropTypes.string,
  withResetButton: PropTypes.bool,
  onResetClick: PropTypes.func,
};

BlockHeading.defaultProps = {
  withResetButton: false,
  onResetClick: noop,
};

export default BlockHeading;
